import {
  faExclamationCircle,
  faTimes,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  error?: boolean;
  text: string;
  onClose: () => void;
  className?: string;
};

const Banner = ({ className, error, onClose, text }: Props) => {
  return (
    <div
      className={`banner ${error ? 'banner--error' : ''} ${
        className ? className : ''
      }`}
    >
      {error && (
        <FontAwesomeIcon
          className="font-size-20 color-error-700"
          icon={faExclamationCircle}
        />
      )}

      <p className={`body-s ${error ? 'color-error-700' : ''}`}>{text}</p>
      <FontAwesomeIcon
        className={`font-size-20 cursor-pointer ${
          error ? 'color-error-700' : ''
        }`}
        icon={faTimes}
        onClick={onClose}
      />
    </div>
  );
};

export default Banner;
